<form *ngIf="userFormGroup" [formGroup]="userFormGroup">
    <p-card styleClass="p-3 p-card-content-pt-0 p-card-content-pb-0">
        <ng-template pTemplate="header">
            <div class="flex justify-content-center align-items-center pb-0 gap-2">
                <div class="p-card-title">Datos generales</div>
                <div class="flex-grow-1"></div>
                <div class="flex align-items-center">
                    <p-messages [closable]="true" size="small" *ngIf="userFormGroup.get('active')?.value==false" severity="error" text="">
                         <ng-template pTemplate>
                            Por favor, recuerde reasignar los expedientes.
                        </ng-template>
                    </p-messages>
                    <label for="active" class="mr-1">Activo</label>
                    <p-inputSwitch formControlName="active" d-form-field-error (onChange)="activeAbsence()"></p-inputSwitch>
                </div>
            </div>
        </ng-template>
        <div class="grid">
            <div class="col-6 input-field">
                <label for="name">Nombre *</label>
                <input pInputText formControlName="name" d-form-field-error />
            </div>
            <div class="col-6 input-field">
                <label for="userName">Nombre de usuario *</label>
                <input pInputText formControlName="userName" inputId="userName" d-form-field-error />
            </div>


            <div class="col-6 input-field"> 
                <label for="email">Email</label>
                <input pInputText type="email" formControlName="email" autocomplete="new-password" d-form-field-error />
            </div>

            <div class="col-6 input-field">
                <label for="vatNumber">NIF/CIF</label>
                <input pInputText formControlName="vatNumber" d-form-field-error />
            </div>

            <div class="col-6 input-field">
                <label for="userTypeId">Tipo de usuario</label>
                <p-dropdown [options]="userTypes" (onChange)="changeUserType($event)" formControlName="userTypeId"
                    optionLabel="name" optionValue="id" [filter]="true" filterBy="name"
                    placeholder="Seleccione tipo de usuario" d-form-field-error />
            </div>
            <div class="col-3 input-field" *ngIf="userTypeSelected?.code=='technical'">
                <label for="workerUserId">Trabajador Técnico asociado</label>
                <p-dropdown [options]="usersTechnicals" formControlName="workerUserId" optionValue="id" [filter]="true" filterBy="name" (onFilter)="loadUsersTechnical($event)"
                    optionLabel="name" placeholder="Seleccione trabajador" d-form-field-error  appendTo="body" showClear (onclear)="loadUsersTechnical(null)"  />
            </div>
            <div class="col-2 input-field" *ngIf="userTypeSelected?.enableServiceEvaluations">
                <label for="maxServiceEvaluatedPercent">Porcentaje (%) de servicios a evaluar</label>
                <p-inputNumber inputId="integeronly" formControlName="maxServiceEvaluatedPercent" [min]="0" [max]="100"
                    suffix=" %" placeholder="0% - 100%" d-form-field-error class="w-full" styleClass="w-full" />
            </div>

            <div class="col-2 input-field" *ngIf="userTypeSelected?.code=='processor'">
                <label for="max_cases_day">Max expedientes diarios</label>
                <p-inputNumber inputId="integeronly" formControlName="max_cases_day" [min]="0" d-form-field-error
                    class="w-full" styleClass="w-full" />
            </div>
            <div class="col-2 input-field" *ngIf="userTypeSelected?.code=='processor'">
                <label for="max_cases_actives">Max expedientes activos</label>
                <p-inputNumber inputId="integeronly" formControlName="max_cases_actives" [min]="0" d-form-field-error
                    class="w-full" styleClass="w-full" />
            </div>
            <div class="col-2 input-field" *ngIf="userTypeSelected?.code=='processor'">
                <label for="capacityPercent">Porcentaje (%) capacidad</label>
                <p-inputNumber inputId="integeronly" formControlName="capacityPercent" [min]="0" [max]="100" suffix=" %"
                    d-form-field-error class="w-full" styleClass="w-full" />
                <ng-template />
            </div>
            
            <div class="col-2 input-field" *ngIf="userTypeSelected?.code=='processor'">
                <label for="absence">Ausente</label>
                <p-inputSwitch formControlName="absence" d-form-field-error></p-inputSwitch>
            </div>
            
            <div class="col-5 input-field" *ngIf="!user.id">
                <label for="password">Contraseña</label>
                <input pPassword type="password" formControlName="password" autocomplete="new-password"
                    d-form-field-error />
            </div>
        </div>
        <div class="grid">
            <div class="col-6 input-field">
                <label for="languageId">Idioma</label>
                <p-dropdown [options]="languages" formControlName="languageId" optionLabel="name" optionValue="id"
                    [filter]="true" filterBy="name" placeholder="Seleccione idioma" d-form-field-error />
            </div>
            <div class="col-3 input-field">
                <label for="roleId">Rol</label>
                <p-dropdown [options]="roles" formControlName="roleId" optionLabel="title" optionValue="id"
                    [filter]="true" filterBy="title" placeholder="Seleccione rol" d-form-field-error />
            </div>
            <div class="col-3 input-field">
                <label for="secondUserId">Segundo</label>
                <p-dropdown [options]="users" formControlName="secondUserId" optionValue="id" [filter]="true" filterBy="name" (onFilter)="loadUsers($event)"
                    optionLabel="name" placeholder="Seleccione su segundo usuario" d-form-field-error  appendTo="body" showClear (onclear)="loadUsers(null)"  />
            </div>
        </div>

        
        <div class="mt-4 flex gap-2 justify-content-end">
            <p-button label="Eliminar" *ngIf="allowDelete && user.id" icon="pi pi-trash" styleClass="p-button-danger"
                (click)="delete()"></p-button>
            <div class="flex-grow-1"></div>
            <p-button label="Recuperar expedientes" icon="pi pi-folder-open" *ngIf="userFormGroup.get('absence')?.value" (click)="recoverCases()" styleClass="mr-3" ></p-button>
            <p-button label="Reasignar expedientes" icon="pi pi-folder-open" *ngIf="userFormGroup.get('absence')?.value" (click)="reassignCases()" styleClass="mr-3" ></p-button>
            <p-button label="Modificar Contraseña" icon="pi pi-pencil" (onClick)="visibleChangePass=true" styleClass="mr-3" ></p-button>

            <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
            <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2"
                (click)="save()"></p-button>
        </div>

    </p-card>

    <p-tabView>
        <p-tabPanel header="Servicios de autenticación">
            <div class="flex justify-content-end mb-2">
                <p-button label="Añadir servicio de autenticación" *ngIf="allowWrite" icon="pi pi-plus"
                    (click)="editAuthService(null)"></p-button>
            </div>

            <p-table styleClass="m-1 mt-4" #grid [value]="userAuthenticationServices" [loading]="loading"
                [paginator]="true" [rows]="25" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
                currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex"
                paginatorDropdownAppendTo="body">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th pSortableColumn="name">Nombre <p-sortIcon field="name" /></th>
                        <th pSortableColumn="active" width="150">Activo <p-sortIcon field="active" /></th>
                        <th pSortableColumn="userIdentifier">Identificador <p-sortIcon
                                field="userIdentifier"></p-sortIcon>
                        </th>
                        <th width="100"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-userAuthenticationService let-columns="columns">
                    <tr (dblclick)="editAuthService(userAuthenticationService)">
                        <td>{{userAuthenticationService.authenticationService.name}}</td>
                        <td><i class="pi"
                                [ngClass]="{ 'text-green-500 pi-check-circle': user.active, 'text-red-500 pi-times-circle': !userAuthenticationService.active }"></i>
                        </td>
                        <td>{{userAuthenticationService.userIdentifier}}</td>
                        <td>
                            <div class="flex gap-2 justify-content-end">
                                <p-button *ngIf="allowDelete" (click)="deleteAuthService(userAuthenticationService)"
                                    [rounded]="true" [text]="false" severity="danger"><i
                                        class="pi pi-trash"></i></p-button>
                                <p-button *ngIf="allowWrite" (click)="editAuthService(userAuthenticationService)"
                                    [rounded]="true" [text]="false"><i class="pi pi-pencil"></i></p-button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </p-tabPanel>
        <p-tabPanel header="Centralita">
            <div class="flex gap-4">
                <div class="input-field">
                    <label for="enableSIPExtension">Activar extensión</label>
                    <p-inputSwitch formControlName="enableSIPExtension" d-form-field-error></p-inputSwitch>
                </div>
                <div class="input-field" *ngIf="userFormGroup.get('enableSIPExtension')?.value">
                    <label for="sipTransport">Transporte SIP</label>
                    <p-dropdown [options]="sipTransports" formControlName="sipTransport" optionLabel="name" optionValue="id"
                        [filter]="true" placeholder="Seleccione transporte" d-form-field-error />
                </div>
                <div class="input-field" *ngIf="userFormGroup.get('enableSIPExtension')?.value">
                    <label for="sipExtension">Extensión</label>
                    <div class="p-inputgroup">
                        <input pInputText formControlName="sipExtension" d-form-field-error />
                        <p-button icon="pi pi-refresh" [pTooltip]="'Buscar extensión libre'" (click)="findFreeExtension()" [disabled]="userFormGroup.get('sipExtension')?.value!=''"></p-button>
                    </div>
                </div>
                <div class="input-field" *ngIf="userFormGroup.get('enableSIPExtension')?.value">
                    <label for="sipExtensionPassword">Password</label>

                    <!-- alta (sin id): se autogenera al cargar y se puede revelar con el ojo -->
                    <p-password *ngIf="!userFormGroup.get('id')?.value" type="password" formControlName="sipExtensionPassword"
                            autocomplete="new-password" [toggleMask]="true" d-form-field-error></p-password>

                    <!-- edición (con id): la API no devuelve la contraseña guardada. No se muestra vacía: se
                         ofrece generar una nueva, que solo puede verse/copiarse en este momento. -->
                    <ng-container *ngIf="userFormGroup.get('id')?.value">
                        <div class="p-inputgroup" *ngIf="generatedSipExtensionPassword != null">
                            <input pInputText [value]="generatedSipExtensionPassword" readonly />
                            <p-button icon="pi pi-copy" [pTooltip]="'Copiar'"
                                    (click)="copyGeneratedSipExtensionPassword()"></p-button>
                        </div>
                        <p-button [label]="generatedSipExtensionPassword == null ? 'Generar nueva' : 'Generar otra'"
                                icon="pi pi-key" (click)="generateSipExtensionPassword()"></p-button>
                        <small *ngIf="generatedSipExtensionPassword != null" style="display:block;margin-top:.25rem">
                            Cópiala ahora: por seguridad no podrá volver a verse una vez guardes.
                        </small>
                    </ng-container>
                </div>
                <div class="input-field" *ngIf="userFormGroup.get('enableSIPExtension')?.value">
                    <label for="outboundDDIId">Número asociado</label>
                    <p-dropdown [options]="ddis" formControlName="outboundDDIId" optionLabel="phoneNumber" optionValue="id"
                        [filter]="true" filterBy="phoneNumber" placeholder="Seleccione número" d-form-field-error />
                </div>
            </div>
        </p-tabPanel>
<!--            <div class="flex justify-content-end pb-1">
                <p-button label="Añadir grupo" (click)="addGroup()" styleClass="p-button-sm"
                    *ngIf="allowWrite"></p-button>
            </div>
            <p-table styleClass="mt-4" [value]="groups" [paginator]="true" [rows]="25"
                [totalRecords]="totalGroupsRecords" [showCurrentPageReport]="true"
                currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex"
                paginatorDropdownAppendTo="body">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th pSortableColumn="group.name">Grupo <p-sortIcon field="group.name"></p-sortIcon></th>
                        <th width="100"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-userGroup let-columns="columns">
                    <tr>
                        <td>{{userGroup.group?.name}}</td>
                        <td>
                            <div class="flex gap-2 justify-content-end">
                                <p-button *ngIf="allowDelete" (click)="deleteGroup(userGroup)" [rounded]="true"
                                    styleClass="p-button-xs p-button-danger"><i class="pi pi-trash"></i></p-button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td [attr.colspan]="2">
                            No se han encontrado grupos
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </p-tabPanel>-->
        <p-tabPanel header="Notificaciones">
            <div class="">
                <div class="flex align-items-center">
                    <label for="enableWorkerSeizureNotification" class="mr-1">Notificar si se registra un fin de un embargo</label>
                    <p-inputSwitch formControlName="enableWorkerSeizureNotification" d-form-field-error></p-inputSwitch>
                </div>
                <div class="flex align-items-center">
                    <label for="enableVehiclePolizyExpiredNotification" class="mr-1">Notificar si se vence una poliza de vehículo</label>
                    <p-inputSwitch formControlName="enableVehiclePolizyExpiredNotification" d-form-field-error></p-inputSwitch>
                </div>
                 <div class="flex align-items-center">
                    <label for="enableHolidaysNotification" class="mr-1">Notificar si operario registra exceso de vacaciones (10 días consecutivos)</label>
                    <p-inputSwitch formControlName="enableHolidaysNotification" d-form-field-error></p-inputSwitch>
                </div>
                <div class="flex align-items-center">
                    <label for="enableKeepGuardShiftNotification" class="mr-1">Notificar si el operario coge vacaciones/baja o bloquea un día que tiene asignada una guardia y no la atiende </label>
                    <p-inputSwitch formControlName="enableKeepGuardShiftNotification" d-form-field-error></p-inputSwitch>
                </div>
                <div class="flex align-items-center">
                    <label for="enableOperatorRejectAllDayNotification" class="mr-1">Notificar si el operario marca que no atiende a todos los servicios del día </label>
                    <p-inputSwitch formControlName="enableOperatorRejectAllDayNotification" d-form-field-error></p-inputSwitch>
                </div>
                <div class="flex align-items-center">
                    <label for="enableClientCompensationNotification" class="mr-1">Notificar si se crea una indemnización a cliente </label>
                    <p-inputSwitch formControlName="enableClientCompensationNotification" d-form-field-error></p-inputSwitch>
                </div>
            </div>
        </p-tabPanel>
    </p-tabView>
</form>
<p-confirmDialog></p-confirmDialog>

<p-dialog header="Modificar contraseña" [modal]="true" [(visible)]="visibleChangePass" [style]="{ width: '300px' }">
    <div class="grid">
        <div class="col-12 input-field">
            <label for="password" class="p-col-4">Cambiar contraseña</label>
            <input pPassword type="password" id="password" class="flex-auto" autocomplete="off" [(ngModel)]="password" aria-label="Constraseña" />
        </div>
    </div>
    <div class="mt-4 flex gap-2 justify-content-end">
        <p-button label="Cerrar" icon="pi pi-times" styleClass="p-button-secondary" (click)="visibleChangePass = false"></p-button>
        <p-button label="Guardar" icon="pi pi-save"  (click)="saveChangePassword(password)"></p-button>
    </div>
</p-dialog>